<ndt-add-account-auto-attendant-keys-view
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onSubmit()"
   [form]="form"
   [autoAttendantKeysArray]="keysFormArray"
   [addedExtensions]="addedExtensions"
></ndt-add-account-auto-attendant-keys-view>
